import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePageWithBody } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/thanks-download-uar-toolkit")({
  loader: async () => {
    const page = await loadStandalonePageWithBody({ data: { path: "thanks-download-uar-toolkit.md" } });
    return { title: (page.title as string) || "Thank You", html: page.html as string };
  },
  head: ({ loaderData }) => ({ meta: seo({ title: loaderData?.title || "Thank You", url: "/thanks-download-uar-toolkit", noindex: true }),
    links: seoLinks({ url: "/thanks-download-uar-toolkit" }), }),
  component: () => {
    const { title, html } = Route.useLoaderData();
    return (
      <div className="mx-auto max-w-3xl px-4 py-16 text-center md:px-8">
        <h1 className="mb-6 text-4xl font-bold text-charcoal">{title}</h1>
        {html && <div className="content" dangerouslySetInnerHTML={{ __html: html }} />}
      </div>
    );
  },
});
